import { render } from "./SimpleModal.vue?vue&type=template&id=116ac40a&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=116ac40a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116ac40a"]])

export default __exports__